<template>
  <v-container class="pa-0" fluid>
    <!-- Snackbar -->
    <SnackbarMessage ref="snackbar" />

    <!-- Layout paginado -->
    <PaginatedLayout :items="tables" @update-page="updatePage" class="pb-15">
      <!-- Header -->
      <template v-slot:header>
        <DeltiaCard>
          <!-- Columna para el título -->
          <v-col cols="12" md="7" class="mb-6">
            <p class="display-1 font-weight-bold mb-0 pb-0">Mesas</p>
          </v-col>
          <!-- Columna para el botón de agregar usuarios -->
          <v-col cols="12" md="5" align="right" class="mb-6">
            <!-- Botón principal -->
            <PrimaryButton @click="$router.push({ name: 'new-table' })">
              Nueva mesa
            </PrimaryButton>
          </v-col>
        </DeltiaCard>
      </template>
      <!-- Sucursales -->
      <template v-slot:items>
        <!-- Pantalla de carga -->
        <LoadingLayout v-if="isLoading">
          <LinearLoading>
            Cargando mesas
          </LinearLoading>
        </LoadingLayout>
        <!-- Items -->
        <v-row v-else v-for="table in tables.docs" :key="table._id" no-gutters>
          <TableItem
            :table="table"
            @table-deleted="tableDeleted"
            @table-error="onTablesError"
          />
        </v-row>
      </template>
    </PaginatedLayout>
  </v-container>
</template>

<script>
// Importar componentes
import PaginatedLayout from "@/layouts/PaginatedLayout";
import LinearLoading from "@/components/Loading/Linear";
import LoadingLayout from "@/layouts/LoadingLayout";
import SnackbarMessage from "@/components/SnackbarMessage";
import DeltiaCard from "@/components/DeltiaCard";
import PrimaryButton from "@/components/PrimaryButton";
import TableItem from "@/components/tables/TableItem";

// Importar servicios
import TablesServices from "@/services/TablesServices";

export default {
  components: {
    LinearLoading,
    LoadingLayout,
    PaginatedLayout,
    SnackbarMessage,
    DeltiaCard,
    PrimaryButton,
    TableItem
  },
  data: function() {
    return {
      tables: { docs: [] },
      isLoading: true
    };
  },
  mounted: async function() {
    // Actualizar página
    await this.updatePage();
  },
  methods: {
    updatePage: async function(page = 1) {
      try {
        // Mostrar pantalla de carga
        this.isLoading = true;

        // Obtener las mesas del negocio
        this.tables = await TablesServices.getTablesByBusiness(page);

        // Ocultar pantalla de carga
        this.isLoading = false;
      } catch (err) {
        // Mostrar error
        this.onTablesError(err.message);
      }
    },
    onTablesError: async function(errorMessage) {
      // Mostrar error
      this.$refs.snackbar.showError(errorMessage);
    },
    tableDeleted: async function() {
      // Mostrar mensaje de éxito
      this.$refs.snackbar.showSuccessMessage("Mesa eliminada con éxito");

      // Obtener ventas
      await this.updatePage();
    }
  }
};
</script>
<style lang=""></style>
